import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Scadenza} from "../Models/Scadenza";
import {EditScadenzaComponent} from "../edit-scadenza/edit-scadenza.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ScadenzeStoreService} from "../_services/scadenze-store.service";
import {Rma} from "../../rma/_Models/rma";
import {RmaEditComponent} from "../../rma/rma-edit/rma-edit.component";
import {RmaStoreService} from "../../rma/_services/rma-store.service";

@Component({
  selector: 'app-scadenze-list',
  templateUrl: './scadenze-list.component.html',
  styleUrls: ['./scadenze-list.component.css']
})
export class ScadenzeListComponent implements OnInit {
  @Input() ListaScadenze: Scadenza[] = [];
  @Input() Padre: any = null;
  @Output() AddButtonClick = new EventEmitter<Scadenza>();
  @Output() Updated = new EventEmitter<Scadenza>();
  constructor(
    private modalService: NgbModal,
    private scadenzeStore: ScadenzeStoreService,
    private RmaStore: RmaStoreService,
  ) { }

  ngOnInit(): void {
  }

  whoismyfather(){
    console.log(this.Padre)
    if (this.Padre && !this.Padre.rma)
      this.ScadModBtn(this.Padre)
    else if (this.Padre && this.Padre.rma) {
      this.RmaStore.updateSelected(this.Padre);
      const editmodal = this.modalService.open(RmaEditComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<RmaEditComponent>editmodal.componentInstance).IsModal = true;
      (<RmaEditComponent>editmodal.componentInstance).added.subscribe(data=>{});
      (<RmaEditComponent>editmodal.componentInstance).updated.subscribe(data=> {});
    }
  }

  ScadAddButton() {
    this.AddButtonClick.emit();
  }
  ScadModBtn(event) {
    this.scadenzeStore.updateScadenzaSelezionata(event);
    const editmodal = this.modalService.open(EditScadenzaComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<EditScadenzaComponent>editmodal.componentInstance).IsModal = true;
    (<EditScadenzaComponent>editmodal.componentInstance).added.subscribe(data=>{});
    (<EditScadenzaComponent>editmodal.componentInstance).updated.subscribe(data=> {this.Updated.emit()});
  }
}
